<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tochead"><a id="page_3">Contents</a></h1><a id="page_3">
</a><h2 class="tocfm"><a id="page_3"></a><a href="#/xhtml/04_Acknowledgements">Acknowledgements</a></h2>
<h2 class="tocfm"><a href="#/xhtml/05_Abbreviations">Abbreviations</a></h2>
<h2 class="tocchac"><a href="#/xhtml/06_Chapter01">Chapter One</a></h2>
<h2 class="toccha"><a href="#/xhtml/06_Chapter01">Overview of the South-West Pacific Area in 1942 and the Strategic Importance of Papua</a></h2>
<p class="tocch"><a href="#/xhtml/06_Chapter01#map1"><span class="tochang">Map 1:</span> Strategic overview of the Pacific War, 1941–1942</a></p>
<p class="tocch"><a href="#/xhtml/06_Chapter01#map2"><span class="tochang">Map 2:</span> The Solomon Islands and Bismarck Archipelago, 1942–1943</a></p>
<p class="tocch"><a href="#/xhtml/06_Chapter01#map3"><span class="tochang">Map 3:</span> The Papuan Campaign, July 1942–January 1943</a></p>
<p class="tocch"><a href="#/xhtml/06_Chapter01#map4"><span class="tochang">Map 4:</span> MacArthur’s counter-offensive against the Buna–Giruwa–Sanananda–Gona Front, November 1942</a></p>
<h2 class="tocchac"><span href="#/xhtml/07_Chapter02" title="Link target outside of Sample">Chapter Two</span></h2>
<h2 class="toccha"><span href="#/xhtml/07_Chapter02" title="Link target outside of Sample">Terrain, Weaponry and Fortifications</span></h2>
<p class="tocch"><span href="#/xhtml/07_Chapter02#map5" title="Link target outside of Sample"><span class="tochang">Map 5:</span> Allied combat on the <em class="italic">Warren</em> Force Front, 18–28 December 1942</span></p>
<h2 class="tocchac"><span href="#/xhtml/08_Chapter03" title="Link target outside of Sample">Chapter Three</span></h2>
<h2 class="toccha"><span href="#/xhtml/08_Chapter03" title="Link target outside of Sample">Commanders and Combatants</span></h2>
<h2 class="tocchac"><span href="#/xhtml/09_Chapter04" title="Link target outside of Sample">Chapter Four</span></h2>
<h2 class="toccha"><span href="#/xhtml/09_Chapter04" title="Link target outside of Sample">The Allied Attacks on Buna, 16 November 1942 to 22 January 1943</span></h2>
<p class="tocch"><span href="#/xhtml/09_Chapter04#map6" title="Link target outside of Sample"><span class="tochang">Map 6:</span> Combat on the <em class="italic">Urbana</em> Force Front, 18–28 December 1942</span></p>
<h2 class="tocchac"><span href="#/xhtml/10_Chapter05" title="Link target outside of Sample">Chapter Five</span></h2>
<h2 class="toccha"><span href="#/xhtml/10_Chapter05" title="Link target outside of Sample">The Allied Attacks on Gona, Sanananda, and Giruwa</span></h2>
<h2 class="tocbm"><span href="#/xhtml/11_Epilogue" title="Link target outside of Sample">Epilogue</span></h2>
<h2 class="tocbm"><span href="#/xhtml/12_References" title="Link target outside of Sample">References</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?0d4ddf2a